import React from 'react'
import NavBar from './NavBar'


function Header() {
    return (
        <div className="app-header">
            <NavBar />
        </div>
    )
}

export default Header

